import React, { useEffect, useState, useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import Swal from "sweetalert2";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import {
  createShiftTemplateApi,
  deleteUserShiftApi,
  findShiftsApi,
  findUserShiftsApi,
  ListShifts,
  ListUserShifts,
  upsertUserShiftApi,
} from "../../_App/Redux/Slices/users/userShiftSlice";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  findUsersApi,
  ListUsers,
} from "../../_App/Redux/Slices/users/userSlice";
import frLocale from "@fullcalendar/core/locales/fr"; // Add this import
import moment from "moment";

const ShiftsManagement = () => {
  const weekDayNames = [
    { id: 0, name: "Dim" },
    { id: 1, name: "Lun" },
    { id: 2, name: "Mar" },
    { id: 3, name: "Mer" },
    { id: 4, name: "Jeu" },
    { id: 5, name: "Ven" },
    { id: 6, name: "Sam" },
  ];
  const dispatch = useAppDispatch();
  const userShifts = useAppSelector(ListUserShifts);
  const shiftsTemplates = useAppSelector(ListShifts);
  const users = useAppSelector(ListUsers);

  const [showModal, setShowModal] = useState(false);
  const [selectedShift, setSelectedShift] = useState<any>(null);
  const [form, setForm] = useState({
    user_code: "",
    shift_id: "",
    custom_start: "",
    custom_end: "",
    start_date: moment().startOf("day").format("YYYY-MM-DD"),
    end_date: moment().startOf("day").format("YYYY-MM-DD"),
    week_days: [] as number[],
    week_parity: "",
  });
  // Helper to check week parity
  const isWeekParityValid = (weekParity: string, currentDate: Date) => {
    if (!weekParity || weekParity === "") return true;

    // Get ISO week number (1-53)
    const getWeekNumber = (date: Date) => {
      const firstJan = new Date(date.getFullYear(), 0, 1);
      const days = Math.floor(
        (date.getTime() - firstJan.getTime()) / (24 * 60 * 60 * 1000),
      );
      return Math.ceil((days + firstJan.getDay() + 1) / 7);
    };

    const weekNumber = getWeekNumber(currentDate);
    const isEven = weekNumber % 2 === 0;

    return weekParity === "even" ? isEven : !isEven;
  };
  useEffect(() => {
    dispatch(findUserShiftsApi());
    dispatch(findShiftsApi());
    dispatch(findUsersApi(null));
  }, [dispatch]);
  // Add this function to filter events based on current view date
  const getFilteredEvents = (currentDate: any) => {
    return userShifts
      .map((us: any) => {
        let startTime = us.custom_start || us.shift?.start_time;
        let endTime = us.custom_end || us.shift?.end_time;
        const processed = processOvernightShift(startTime, endTime);

        // Check date range
        const shiftStartDate = us.start_date ? new Date(us.start_date) : null;
        const shiftEndDate = us.end_date ? new Date(us.end_date) : null;
        const currentViewDate = currentDate || new Date();

        if (shiftStartDate && currentViewDate < shiftStartDate) return null;
        if (shiftEndDate && currentViewDate > shiftEndDate) return null;

        // Check week parity
        if (!isWeekParityValid(us.week_parity, currentViewDate)) return null;

        return {
          id: us.id?.toString(),
          resourceId: us.user_code,
          title: us.shift?.name || "Poste",
          user: us.User,
          startTime: processed.startTime,
          endTime: processed.endTime,
          daysOfWeek:
            typeof us.week_days === "string"
              ? us.week_days.split(",").map(Number)
              : us.week_days,
          backgroundColor: us.shift?.color || "#3f51b5",
          extendedProps: { ...us },
        };
      })
      .filter((event) => event !== null);
  };
  const [currentDateRange, setCurrentDateRange] = useState({
    start: null,
    end: null,
  });
  const handleEventDataTransform = (eventData: any) => {
    const eventStartDate = eventData.start;
    if (!eventStartDate) return eventData;

    const eventDataObj = eventData.extendedProps;

    // Check date range
    if (
      eventDataObj.start_date &&
      new Date(eventDataObj.start_date) > eventStartDate
    ) {
      return null;
    }
    if (
      eventDataObj.end_date &&
      new Date(eventDataObj.end_date) < eventStartDate
    ) {
      return null;
    }

    // Check week parity
    if (!isWeekParityValid(eventDataObj.week_parity, eventStartDate)) {
      return null;
    }

    return eventData;
  };
  // Transforme les plannings utilisateur en ressources FullCalendar (Lignes)
  const resources = userShifts.map((us: any) => ({
    id: us.user_code,
    title: `${us.User?.prenom} ${us.User?.nom}`,
    extendedProps: { photo: us.User?.photo, role: us.User?.role_code },
  }));

  // Transforme les plannings utilisateur en événements récurrents
  console.log(userShifts);
  const processOvernightShift = (startTime: string, endTime: string) => {
    if (!startTime || !endTime) return { startTime, endTime };

    // Convert to comparable numbers
    const startHour = parseInt(startTime.split(":")[0]);
    const endHour = parseInt(endTime.split(":")[0]);

    // If end hour is less than start hour, it's overnight
    if (
      endHour < startHour ||
      (endHour === startHour && endTime <= startTime)
    ) {
      const [endHourNum, endMinute] = endTime.split(":");
      const nextDayHour = parseInt(endHourNum) + 24;
      return {
        startTime: startTime,
        endTime: `${nextDayHour.toString().padStart(2, "0")}:${endMinute}`,
      };
    }
    return { startTime, endTime };
  };
  const events = userShifts.map((us: any) => {
    let startTime = us.custom_start || us.shift?.start_time;
    let endTime = us.custom_end || us.shift?.end_time;

    // Process overnight shifts
    const processed = processOvernightShift(startTime, endTime);

    return {
      id: us.id?.toString(),
      resourceId: us.user_code,
      title: us.shift?.name || "Poste",
      user: us.User,
      startTime: processed.startTime,
      endTime: processed.endTime,
      daysOfWeek:
        typeof us.week_days === "string"
          ? us.week_days.split(",").map(Number)
          : us.week_days,
      backgroundColor: us.shift?.color || "#3f51b5",
      extendedProps: { ...us },
    };
  });

  const handleEventClick = (info: any) => {
    const data = info.event.extendedProps;
    setSelectedShift(data);
    setForm({
      user_code: data.user_code,
      shift_id: data.shift_id,
      custom_start: data.custom_start || "",
      custom_end: data.custom_end || "",
      start_date: data.start_date,
      end_date: data.end_date,
      week_days:
        typeof data.week_days === "string"
          ? data.week_days.split(",").map(Number)
          : data.week_days,
      week_parity: data.week_parity,
    });
    setShowModal(true);
  };

 const handleSave = async () => {
  if (!form.user_code || !form.shift_id) {
    return Swal.fire(
      "Erreur",
      "Sélectionnez un utilisateur et un poste",
      "warning",
    );
  }

  const result = await dispatch(
    upsertUserShiftApi({
      userCode: form.user_code,
      data: {
        ...form,
        shift_id: Number(form.shift_id),
        week_days: form.week_days.join(","),
        start_date: form.start_date || null,
        end_date: form.end_date || null,
        week_parity: form.week_parity || null,
      },
    }),
  );

  if (upsertUserShiftApi.fulfilled.match(result)) {
    await Swal.fire("Succès", "Planning mis à jour", "success");

    setShowModal(false);

    window.location.reload();
  }
};
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [templateForm, setTemplateForm] = useState({
    name: "",
    start_time: "08:00",
    end_time: "16:00",
    color: "#3f51b5",
  });

  // Fonction pour enregistrer un modèle de poste
  const handleSaveTemplate = async () => {
    if (!templateForm.name)
      return Swal.fire("Erreur", "Le nom est requis", "error");

    const result = await dispatch(createShiftTemplateApi(templateForm));

    if (createShiftTemplateApi.fulfilled.match(result)) {
      Swal.fire("Succès", "Nouveau modèle de poste créé", "success");
      setShowTemplateModal(false);
      setTemplateForm({
        name: "",
        start_time: "08:00",
        end_time: "16:00",
        color: "#3f51b5",
      });
    }
  };
  useEffect(() => {
    if (form.shift_id) {
      const selectedTemplate = shiftsTemplates.find(
        (s) => s.id === Number(form.shift_id),
      );
      if (selectedTemplate) {
        setForm((prev) => ({
          ...prev,
          custom_start: selectedTemplate.start_time,
          custom_end: selectedTemplate.end_time,
        }));
      }
    }
  }, [form.shift_id, shiftsTemplates]);

  return (
    <div className="calendar-container p-4 bg-white rounded shadow-sm">
      <div
        className="mb-4"
        style={{ display: "flex", alignItems: "center", justifyContent: "end" }}
      >
        <div className="d-flex gap-2">
          <Button
            variant="outline-secondary"
            onClick={() => setShowTemplateModal(true)}
          >
            ⚙️ Gérer les modèles
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              setSelectedShift(null);
              setShowModal(true);
            }}
          >
            + Assigner un poste
          </Button>
        </div>
      </div>

      <FullCalendar
        plugins={[timeGridPlugin, interactionPlugin]}
        locale={frLocale} // Add this line to set French locale
        initialView="timeGridWeek"
        headerToolbar={{
          left: "today prev,next",
          center: "title",
          right: "timeGridDay,timeGridWeek,dayGridMonth",
        }}
        events={events}
        eventDataTransform={handleEventDataTransform}
        height="auto"
        slotEventOverlap={false} // Prevents events from overlapping/hiding each other
        eventDisplay="block" // Forces a block-style look
        eventMinWidth={100}
        eventClick={handleEventClick}
        slotMinTime="00:00:00"  // Temporarily change to 00:00
  slotMaxTime="24:00:00"  // Temporarily change to 24:00
        allDaySlot={false}
        eventContent={(eventInfo) => (
          <div className="custom-event-card shadow-sm">
            <div className="fw-bold text-truncate">{eventInfo.event.title}</div>
            <div className="d-flex align-items-center mt-1">
              <img
                src={
                  eventInfo.event.extendedProps.User?.photo ||
                  "/assets/assets/img/no-image.jpg"
                }
                className="rounded-circle me-1 border"
                style={{ width: "20px", height: "20px", objectFit: "cover" }}
              />
              <small className="text-truncate">
                {eventInfo.event.extendedProps.user?.nom}
              </small>
            </div>
          </div>
        )}
      />

      {/* Modal de gestion (Ajouter/Modifier/Supprimer) */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedShift ? "Modifier le poste" : "Nouvelle affectation"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Logique de sélection utilisateur */}
            <Form.Group className="mb-3">
              <div className="contact-name">
                <i className="flaticon-user-11"></i>
                <select
                  className="form-control"
                  value={form.user_code}
                  onChange={(e) =>
                    setForm({ ...form, user_code: e.target.value })
                  }
                >
                  <option value="">Affecter un utilisateur</option>
                  {users?.map((item) => (
                    <option key={item.code} value={item.code}>
                      {item.prenom} {item.nom}
                    </option>
                  ))}
                </select>
                <span className="validation-text"></span>
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Modèle de poste</Form.Label>
              <Form.Select
                value={form.shift_id}
                onChange={(e) => setForm({ ...form, shift_id: e.target.value })}
              >
                <option value="">Sélectionner un poste...</option>
                {shiftsTemplates.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name} ({s.start_time}-{s.end_time})
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Row className="mb-3">
              <Col>
                <Form.Label>Date de début</Form.Label>
                <Form.Control
                  type="date"
                  value={form.start_date || ""}
                  onChange={(e) =>
                    setForm({ ...form, start_date: e.target.value })
                  }
                  placeholder="AAAA-MM-JJ"
                />
              </Col>
              <Col>
                <Form.Label>Date de fin</Form.Label>
                <Form.Control
                  type="date"
                  value={form.end_date || ""}
                  onChange={(e) =>
                    setForm({ ...form, end_date: e.target.value })
                  }
                  placeholder="AAAA-MM-JJ"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>Début personnalisé (Optionnel)</Form.Label>
                <Form.Control
                  type="time"
                  value={form.custom_start}
                  onChange={(e) =>
                    setForm({ ...form, custom_start: e.target.value })
                  }
                />
              </Col>
              <Col>
                <Form.Label>Fin personnalisée (Optionnel)</Form.Label>
                <Form.Control
                  type="time"
                  value={form.custom_end}
                  onChange={(e) =>
                    setForm({ ...form, custom_end: e.target.value })
                  }
                />
              </Col>
              <Form.Group className="mt-3">
                <Form.Label>Jours de travail</Form.Label>
                <div className="d-flex flex-wrap gap-2">
                  {weekDayNames.map((day) => (
                    <Button
                      key={day.id}
                      size="sm"
                      variant={
                        form.week_days.includes(day.id)
                          ? "primary"
                          : "outline-secondary"
                      }
                      onClick={() => {
                        const active = form.week_days.includes(day.id)
                          ? form.week_days.filter((d) => d !== day.id)
                          : [...form.week_days, day.id];
                        setForm({ ...form, week_days: active });
                      }}
                    >
                      {day.name}
                    </Button>
                  ))}
                </div>
              </Form.Group>
             
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          {selectedShift && (
            <Button
              variant="outline-danger"
              onClick={() => {
                dispatch(deleteUserShiftApi(selectedShift.user_code));
                setShowModal(false);
              }}
            >
              Supprimer
            </Button>
          )}
          <Button variant="primary" onClick={handleSave}>
            Enregistrer les modifications
          </Button>
        </Modal.Footer>
      </Modal>
      {/* MODAL POUR CRÉER DES MODÈLES DE POSTES */}
      <Modal
        show={showTemplateModal}
        onHide={() => setShowTemplateModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Créer un nouveau modèle de poste</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Nom du poste (ex: Matin, Nuit)</Form.Label>
              <Form.Control
                value={templateForm.name}
                onChange={(e) =>
                  setTemplateForm({ ...templateForm, name: e.target.value })
                }
                placeholder="Entrez un nom..."
              />
            </Form.Group>

            <Row className="mb-3">
              <Col>
                <Form.Label>Heure de début</Form.Label>
                <Form.Control
                  type="time"
                  value={templateForm.start_time}
                  onChange={(e) =>
                    setTemplateForm({
                      ...templateForm,
                      start_time: e.target.value,
                    })
                  }
                />
              </Col>
              <Col>
                <Form.Label>Heure de fin</Form.Label>
                <Form.Control
                  type="time"
                  value={templateForm.end_time}
                  onChange={(e) =>
                    setTemplateForm({
                      ...templateForm,
                      end_time: e.target.value,
                    })
                  }
                />
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Couleur du calendrier</Form.Label>
              <Form.Control
                type="color"
                value={templateForm.color}
                onChange={(e) =>
                  setTemplateForm({ ...templateForm, color: e.target.value })
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSaveTemplate}>
            Créer le modèle
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ShiftsManagement;
